module.exports = __webpack_public_path__ + "pc/img/Rectangle.6633d531.png";